var cmsFormConditions = require('/Framework/assets/js/cms-form-conditions')
cmsFormConditions.isFieldVisible = function ($field){
    return $field.closest('.hidden-by-conditions').length  === 0 && !$field.hasClass('hidden-by-conditions')
}
